import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from './login.service';
import { Message } from 'primeng/components/common/api';
import { HttpErrorResponse } from '@angular/common/http';
import { debug } from 'util';

@Component({
    templateUrl: './login.component.html',
    styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit, AfterViewInit {
    @ViewChild('loginIdRef') loginIdRef: ElementRef;
    public growlMessage: Message[] = [];
    public isLoading: boolean = false;
    public institution: string;
    public loginId: string;
    public password: string;
    public institutions: any = [
        {
            name: 'Universal Medical Records',
            value: 'UMHLD'
        },
        {
            name: 'School System',
            value: '10003'
        }
    ];

    constructor(private router: Router, private loginService: LoginService) {
        this.institution = this.institutions[0].value;
    }

  ngOnInit() {
    //console.log(this.loginService.isLoggedIn);
        if (this.loginService.isLoggedIn) {
          this.router.navigate(['/']);
        }
        else if (this.loginService.logoutMessage) {
            this.growlMessage = [];
            this.growlMessage.push({ severity: 'error', summary: '', detail: this.loginService.logoutMessage });
            this.loginService.defaultLogoutMessage = null;
            //setTimeout(() => this.hideGrowlMessage(), 3000);
        }
    }

    ngAfterViewInit() {
        this.loginIdRef.nativeElement.focus();
    }

    //hideGrowlMessage() {
    //    this.growlMessage = [];
    //}

    onLogin() {
        this.isLoading = true;
        this.loginService.login(this.loginId, this.password, this.institution)
            .subscribe(_ => _, err => {
                this.isLoading = false;
                if (err instanceof HttpErrorResponse) {
                    this.growlMessage = [];
                    this.growlMessage.push({ severity: 'error', summary: err.error, detail: '' });
                }
                else if (err.json().error_description) {
                    this.growlMessage = [];
                    this.growlMessage.push({ severity: 'error', summary: err.json().error_description, detail: '' });
                }
                else {
                    this.growlMessage = [];
                    this.growlMessage.push({ severity: 'error', summary: 'Something went wrong on server', detail: '' });
                }
            },
              () => {
                if (this.loginService.logoutMessage) {
                    this.isLoading = false;
                    this.growlMessage = [];
                    this.growlMessage.push({ severity: 'error', summary: '', detail: this.loginService.logoutMessage });
                    this.loginService.defaultLogoutMessage = null;
                }
            });
    }

    onProviderEnrollment() {        
        this.router.navigate(['enroll-provider']);        
    }

    onPatientEnrollment() {
        this.router.navigate(['enroll-patient']); 
    }
}
